import { render } from "./AttachmentDocumentResp.vue?vue&type=template&id=056219d1"
import script from "./AttachmentDocumentResp.vue?vue&type=script&lang=js"
export * from "./AttachmentDocumentResp.vue?vue&type=script&lang=js"

import "./AttachmentDocumentResp.vue?vue&type=style&index=0&id=056219d1&lang=css"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__